import React from 'react';
import { TableRow, TableCell, IconButton, Box, MenuItem, Menu } from '@mui/material';
import { Supplier } from '../../../models/supplier.model';
import styles from '../SupplierProfiles.module.scss';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../common/constants/routes';
import { useTranslation } from 'react-i18next';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useCheckPermission } from '../../../common/hooks/useCheckPermission';
import { USER_PERMISSIONS } from '../../../common/constants/permissions';

type SupplierRowProps = {
  supplier: Supplier;
  navigateToDocs: (id: number) => void;
  handleEdit: (id: number) => void;
  handleDelete: (id: number) => void;
};

export const SupplierRow: React.FC<SupplierRowProps> = ({
  supplier,
  navigateToDocs,
  handleDelete,
  handleEdit,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();
  const { t } = useTranslation();
  const checkPermission = useCheckPermission();
  return (
    <TableRow className={styles.table_row} key={supplier.id}>
      <TableCell
        className={styles.table_cell}
        onClick={() => navigate(`${ROUTES.SUPPLIER_PROFILES}/${supplier.id}`)}
      >
        {supplier.name}
      </TableCell>
      <TableCell
        className={styles.table_cell}
        onClick={() => navigate(`${ROUTES.SUPPLIER_PROFILES}/${supplier.id}`)}
      >
        {supplier.supplier_email || '-'}
      </TableCell>
      <TableCell
        className={styles.table_cell}
        onClick={() => navigate(`${ROUTES.SUPPLIER_PROFILES}/${supplier.id}`)}
      >
        {supplier.registration_number || '-'}
      </TableCell>
      <TableCell
        className={styles.table_cell}
        onClick={() => navigate(`${ROUTES.SUPPLIER_PROFILES}/${supplier.id}`)}
      >
        {supplier.postal_address || '-'}
      </TableCell>
      <TableCell className={styles.table_cell} align='right'>
        <Box
          className={styles.actions_container}
          display='flex'
          justifyContent='flex-end'
          gap='8px'
        >
          <IconButton
            onClick={(event) => {
              event.stopPropagation();
              setAnchorEl(event.currentTarget);
            }}
            size='small'
            sx={{ p: 0.5 }}
          >
            <MoreVertIcon fontSize='small' />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <MenuItem
              onClick={(event) => {
                event.stopPropagation();
                setAnchorEl(null);
                handleEdit(supplier.id);
              }}
              disabled={!checkPermission(USER_PERMISSIONS.ORG_SUPPLIER_PROFILE_UPDATE)}
            >
              {t('buttons.edit')}
            </MenuItem>
            <MenuItem
              onClick={(event) => {
                event.stopPropagation();
                setAnchorEl(null);
                navigateToDocs(supplier.id);
              }}
              disabled={
                !(
                  checkPermission(USER_PERMISSIONS.ORG_SUPPLIER_PROFILE_UPDATE_DOCUMENT) ||
                  checkPermission(USER_PERMISSIONS.ORG_DOCUMENT_UPLOAD_CREATE) ||
                  checkPermission(USER_PERMISSIONS.ORG_SUPPLIER_PROFILE_DELETE_DOCUMENT) ||
                  checkPermission(USER_PERMISSIONS.ORG_DOCUMENT_UPLOAD_ASSIGN_PROFILE)
                )
              }
            >
              {t('buttons.documents')}
            </MenuItem>
            <MenuItem
              onClick={(event) => {
                event.stopPropagation();
                setAnchorEl(null);
                handleDelete(supplier.id);
              }}
              disabled={!checkPermission(USER_PERMISSIONS.ORG_SUPPLIER_PROFILE_DELETE)}
            >
              {t('buttons.delete')}
            </MenuItem>
          </Menu>
        </Box>
      </TableCell>
    </TableRow>
  );
};
